import { useMemo } from "react";

import { useRailways } from "../../../shared/hooks/use-railways";
import { buildConstructorRoads, MOCK_CONSTRUCTOR_ROADS, type ConstructorRoad } from "../constructor-roads-page.lib";

/**
 * Дороги конструктора: базовый справочник (та же ручка, что в форме создания заявки),
 * при недоступности справочника — фолбэк на мок-данные.
 */
export const useConstructorRoads = () => {
  const { railways, isLoading } = useRailways();
  const roads = useMemo<ConstructorRoad[]>(() => (railways.length ? buildConstructorRoads(railways) : MOCK_CONSTRUCTOR_ROADS), [railways]);

  return { roads, isLoading };
};
